var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteStart = function SvgQuoteStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41992 31V21.1777C1.41993 17.4986 2.02939 14.1807 3.23242 11.207L3.48145 10.6172C4.76364 7.69383 6.98516 4.60144 10.1943 1.34277L14.9014 5.13574C12.8713 7.32062 11.3293 9.42203 10.3037 11.4424V11.4434C9.82301 12.3923 9.44675 13.3703 9.16602 14.3789L8.81348 15.6475H17.0527V31H1.41992Z",
    fill: "#65C9DB",
    stroke: "#65C9DB",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5039 31V21.1777C22.5039 17.4986 23.1134 14.1807 24.3164 11.207L24.5654 10.6172C25.8476 7.69383 28.0691 4.60144 31.2783 1.34277L35.9854 5.13574C33.9553 7.32062 32.4133 9.42203 31.3877 11.4424V11.4434C30.907 12.3923 30.5307 13.3703 30.25 14.3789L29.8975 15.6475H38.1367V31H22.5039Z",
    fill: "#65C9DB",
    stroke: "#65C9DB",
    strokeWidth: 2
  })));
};
export default SvgQuoteStart;